/**
 * @typedef {Object} WebAppRunDto
 * @property { AppRunAppointmentDto[] } Appointments
 * @property { AppRunMatrixDto[] } CompetencyExerciseMatrix
 * @property { AppRunCustomerDto } Customer
 * @property { WebAppRunExerciseDto[] } Exercises
 * @property { number } Id
 * @property { boolean } ObserverTraining
 * @property { AppRunParticipantDto[] } Participants
 * @property { number } ScalaCount
 * @property { AppRunScaleDto[] } Scale
 * @property { Date } StartDate
 * @property { RunStatus } Status
 * @property { AppRunTeamDto[] } Teams
 */

/**
 * @typedef { Object } AppRunAppointmentDto
 * @property { boolean } Custom
 * @property { Date } EndTime
 * @property { number } ExerciseId
 * @property { number } Id
 * @property { string } Name
 * @property { number[] } ParticipantIds
 * @property { Date } StartTime
 * @property { number[] } TeamIds
 */

/**
 * @typedef { Object } AppRunMatrixDto
 * @property { number } CompetencyId
 * @property { number } ExerciseId
 * @property { number } Id
 * @property { boolean } SubjectiveOverallImpression
 */

/**
 * @typedef { Object } AppRunCustomerDto
 * @property { string } City
 * @property { number } Id
 * @property { string } Name
 * @property { string } Street
 * @property { string } ZipCode
 */

/**
 * @typedef { Object } WebAppRunExerciseDto
 * @property { WebAppRunExerciseCompetencyDto[] } Competencies
 * @property { AppRunExerciseDocumentDto[] } Documents
 * @property { number } DurationInMinutes
 * @property { ExerciseType } ExerciseType
 * @property { number } Id
 * @property { AppRunExerciseInformationDto[] } Information
 * @property { string } Name
 */

/**
 * Enum for ExerciseType
 * @enum { string }
 */
export const ExerciseType = {
  Single: 0,
  Group: 1,
  Interview: 2,
  Test: 3
}

/**
 * @typedef { Object } WebAppRunExerciseCompetencyDto
 * @property { string } Category
 * @property { string } Definition
 * @property { number } Id
 * @property { string } Name
 */
/**
 * @typedef { Object } AppRunExerciseDocumentDto
 * @property { string } FileType
 * @property { number } Id
 * @property { string } Name
 * @property { ExerciseDocumentType } Type
 * @property { string } Url
 */
/**
 * Enum for ExerciseDocumentType
 * @readonly
 * @enum { string }
 */
export const ExerciseDocumentType = {
  Candidate: 0,
  Observer: 1
}
/**
 * @typedef { Object } AppRunExerciseInformationDto
 * @property { number } Id
 * @property { string } Name
 * @property { AppRunExerciseInformationParagraphDto[] } Paragraphs
 */

/**
 * @typedef { Object } AppRunExerciseInformationParagraphDto
 * @property { number } Id
 * @property { string } Text
 */

/**
 * @typedef { Object } AppRunParticipantDto
 * @property { string } DocumentTypeType
 * @property { string } DocumentName
 * @property { string } DocumentUrl
 * @property { string } FirstName
 * @property { number } Id
 * @property { string } ImageFileType
 * @property { string } ImageUrl
 * @property { string } LastName
 * @property { string } Title
 */
/**
 * @typedef { Object } AppRunScaleDto
 * @property { number } Id
 * @property { string } Name
 * @property { number } ScaleBlockId
 * @property { number } SortOrder
 * @property { number } Value
*/
/**
 * Enum for RunStatus
 * @readonly
 * @enum { number }
 */
export const RunStatus = {
  Planning: 0,
  Running: 1,
  Documented: 2
}
/**
 * @typedef { Object } AppRunTeamDto
 * @property { number } Id
 * @property { AppRunTeamMemberDto[] } Members
 * @property { string } name
 * @property { string } Room
 * @property { TeamType } Type
 */

/**
 * @typedef { Object } AppRunTeamMemberDto
 * @property { string } Abbreviation
 * @property { string } FirstName
 * @property { number } Id
 * @property { boolean } IsObserving
 * @property { string } LastName
 */
/**
 * Enum for TeamType
 * @readonly
 * @enum { string }
 */
export const TeamType = {
  Normal: 0,
  FreeObserver: 1
}

export default {}
